

import ResponsiveTable from '../../../components/ResponsiveTable';
import { hideLoading, showLoading } from '../../../loading';
import request from '../../../request';
import swal from 'sweetalert';
import { DELIVERY_STATUS } from '../../../../../shared/constants';
import { Visibility } from '@mui/icons-material';
import StyledLink from '../../../components/StyledLink';
import links from '../../../links';
import PillLabel from '../../../components/PillLabel';
import Address from '../../../components/Address';
import { IconButton } from '@mui/material';
import { Link } from 'react-router';
import NavigationStateSaver from '../../../components/NavigationStateSaver';


export default class Deliveries extends NavigationStateSaver {

   state = {
      deliveries: null,
      page: 0,
      pageSize: 10,
      total: 0,
      selectStatusAnchorEl: null,
      filters: {
         status: undefined,
         from: undefined,
         to: undefined
      }
   }

   fetchDeliveries = async () => {

      try {

         showLoading();

         const params = {
            page: this.state.page + 1,
            limit: this.state.pageSize
         }

         const { status, from, to } = this.state.filters;
         if (status) params.status = status;
         if (from) params.from = from;
         if (to) params.to = to;

         const res = await request.get('/api/general/deliveries', { params });
         const { deliveries, total } = res.data;

         this.setState({ deliveries, total });

      } catch (err) {
         swal("Error", err.message, "error");
      } finally {
         hideLoading();
      }
   }

   updateStatus = async (data) => {

      if (data) {
         try {

            showLoading();

            const deliveryId = this.state.deliveryBeingUpdated._id;
            const res = await request.patch(`/api/technical/deliveries/${deliveryId}`, data);

            const updatedDelivery = res.data;
            const deliveries = this.state.deliveries.map(d => d._id === updatedDelivery._id ? updatedDelivery : d);

            this.setState({ deliveries });

         } catch (err) {
            swal("Error", err.message, "error");
            return;
         } finally {
            hideLoading();
         }
      }

      this.setState({ selectStatusAnchorEl: null, deliveryBeingUpdated: null });
   }

   async componentDidMount() {
      await super.componentDidMount();
      if (!this.state.deliveries)
         this.fetchDeliveries();
   }

   render() {

      return <>
         <ResponsiveTable
            cols={[
               {
                  field: 'product',
                  caption: 'Product',
                  render: product => product ? product.name : '–',
               },
               {
                  field: 'customer',
                  caption: 'Customer',
                  render: customer => customer ? <StyledLink to={links.customer(customer._id)}>
                     {customer.name} {customer.surname}
                  </StyledLink> : '–',
               },
               {
                  field: 'loan',
                  caption: 'Loan',
                  render: loan => {
                     if (!loan)
                        return '–';
                     return <StyledLink to={links.loan(loan._id)}>
                        {loan.loan_no}
                     </StyledLink>
                  }
               },
               {
                  field: 'customer',
                  caption: 'Address',
                  render: customer => customer?.address ? <Address address={customer.address} /> : '–',
               },
               {
                  field: 'status',
                  caption: 'Status',
                  render: status => <PillLabel className='uppercase'>{status}</PillLabel>
               },
               {
                  field: 'actions',
                  caption: '',
                  render: (_, delivery) => {
                     return <IconButton component={Link} to={links.delivery(delivery._id)}>
                        <Visibility />
                     </IconButton>
                  }
               }
            ]}
            rows={this.state.deliveries}
            fullHeight
            pagination={{
               page: this.state.page,
               rowsPerPage: this.state.pageSize,
               labelRowsPerPage: 'Deliveries per page',
               count: this.state.total,
               onPageChange: (_, page) => this.setState({ page }, this.fetchDeliveries),
               onRowsPerPageChange: e => this.setState({ pageSize: e.target.value }, this.fetchDeliveries)
            }}
            onRefresh={this.fetchDeliveries}
            filters={{
               onChange: filters => this.setState({ filters, page: 0 }, this.fetchDeliveries),
               filters: [
                  {
                     field: 'status',
                     label: 'Status',
                     type: 'select',
                     options: Object
                        .values(DELIVERY_STATUS)
                        .map(status => ({ value: status, label: status.toUpperCase() })),
                     value: this.state.filters.status,
                  },
                  {
                     field: 'from',
                     label: 'From',
                     type: 'date',
                     value: this.state.filters.from,
                  },
                  {
                     field: 'to',
                     label: 'To',
                     type: 'date',
                     value: this.state.filters.to,
                  },
               ],
            }}
         />
      </>
   }
}